import React, { Component } from 'react';

import autoBind from 'react-autobind';
import ProfileSection from 'ui/users/profile-section';
import query from './user-query.gql';
import Loading from 'ui/common/loading';
import Button from 'ui/common/button';

import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { withApollo } from 'react-apollo';
import routeTemplates from 'ui/common/routes/templates';

import { getUserEventEvaluations } from 'store/graphql/UserEvaluations/actions';
import {
  selectEventClaimsEvaluation,
  selectIsFetchingEventClaims,
  selectErrorEventClaims,
} from 'store/graphql/UserEvaluations/selectors';
import { resultHasErrors } from 'utils/graphql-errors';

import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import UserEvaluationsReducer from 'store/graphql/UserEvaluations/reducer';
import ClaimListItem from './claim-list-item';

const {
  start: getUserEvaluationStart,
  success: getUserEvaluationSuccess,
  failure: getUserEvaluationFailure,
} = getUserEventEvaluations;

const messages = defineMessages({
  title: {
    id: 'users.event-evaluation.title',
    defaultMessage: 'Diwali <Giveaway> 2020',
    currentTab: false, // false means all skills
  },
  allEvaluation: {
    id: 'users.evaluation.category.type.all-evaluation',
    defaultMessage: 'All Evaluations',
  },
});

class Evaluations extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    this.executeQuery();
  }

  async executeQuery() {
    const {
      getUserEvaluationStart,
      getUserEvaluationSuccess,
      getUserEvaluationFailure,
      client,
    } = this.props;

    getUserEvaluationStart();

    try {
      const response = await client.query({
        query,
      });

      if (resultHasErrors(response)) {
        getUserEvaluationFailure({ errors: response.errors });
      } else {
        const { getUserEvaluations } = response.data;
        getUserEvaluationSuccess({
          result: {
            chatbots: [],
            assignments: [],
            claims: getUserEvaluations.claims,
          },
        });
      }
    } catch (error) {
      getUserEvaluationFailure({
        errors: error.messages,
      });
    }
  }

  renderClaims() {
    const { claimEvaluation, hasClaims } = this.props;
    const { claims } = claimEvaluation;

    return (
      <div className="pt-3">
        {hasClaims ? (
          claims && claims.map((claim, index) => <ClaimListItem claim={claim} key={index} />)
        ) : (
          <div className="text-center pt-2">
            <p className="pb-3">
              Get your development skills evaluated by our experts by submitting a public project
            </p>
            <Button isReady={true} to={routeTemplates.claims.new}>
              Submit Project
            </Button>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { intl: { formatMessage }, isFetching } = this.props;
    if (isFetching) return <Loading />;

    return (
      <div className="row" id="evaluations">
        <ProfileSection title={formatMessage(messages.title)} collapsible className="col-12 py-4">
          {this.renderClaims()}
        </ProfileSection>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const claimEvaluation = selectEventClaimsEvaluation(state);
  const hasClaims = claimEvaluation && claimEvaluation.claims && claimEvaluation.claims.length > 0;
  return {
    claimEvaluation,
    hasClaims,
    isFetching: selectIsFetchingEventClaims(state),
    error: selectErrorEventClaims(state),
  };
}

const mapDispatchToProps = {
  getUserEvaluationStart,
  getUserEvaluationSuccess,
  getUserEvaluationFailure,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withUserEvaluationsReducer = injectReducer({
  key: 'UserEvaluations',
  reducer: UserEvaluationsReducer,
});

export default compose(withUserEvaluationsReducer, withConnect)(
  injectIntl(withApollo(Evaluations))
);
